import React from "react";
import { useTranslation } from "react-i18next";
import BRANDING from "../../branding";

const WhatsAppButton = () => {
  const { t, i18n } = useTranslation();

  const handleClickWhatsApp = () => {
    if (window.gtag) {
      window.gtag('event', 'whatsapp_click', {
        event_category: 'engagement',
        event_label: 'Floating WhatsApp Button'
      });
    }
    if (window.fbq) {
      window.fbq('track', 'Contact', {
        content_name: 'WhatsApp Click'
      });
    }
    if (window.ttq) {
      window.ttq.track("ViewContent");
      window.ttq.track("Contact");
    }
  };

  const whatsappNumber = BRANDING.socialLinks.whatsapp.replace(/[^0-9]/g, '');
  const whatsappMessage = encodeURIComponent(
    i18n.language?.startsWith('ar')
      ? 'مرحبا، أريد الاستفسار عن منتج'
      : 'Hello, I would like to inquire about a product'
  );

  return (
    <a
      href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
      onClick={handleClickWhatsApp}
      target="_blank"
      rel="noopener noreferrer"
      className={
        i18n.language?.startsWith('ar')
          ? "fixed bottom-20 sm:bottom-6 left-5 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all hover:scale-110"
          : "fixed bottom-20 sm:bottom-6 right-5 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all hover:scale-110"
      }
      aria-label={t('footer.whatsapp_aria')}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M13.601 2.326A7.854 7.854 0 0 0 8.003 0C3.588 0 .002 3.586 0 8c0 1.408.367 2.77 1.067 3.992L0 16l4.129-1.056A7.94 7.94 0 0 0 8.003 16C12.418 16 16 12.414 16 8a7.9 7.9 0 0 0-2.399-5.674z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
